import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOMetaProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogImage,
  ogType = 'website',
}: SEOMetaProps) {
  const location = useLocation();

  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const baseUrl = 'https://qiaojzx.cn';
    const url = canonicalUrl || `${baseUrl}${location.pathname}`;

    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:url', url, true);
    setMeta('og:type', ogType, true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
    }

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title);
    setMeta('twitter:description', description);
    if (ogImage) {
      setMeta('twitter:image', ogImage);
    }

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', url);

    const now = new Date().toUTCString();
    let lastMod = document.querySelector('meta[name="Last-modified"]');
    if (!lastMod) {
      lastMod = document.createElement('meta');
      lastMod.setAttribute('name', 'Last-modified');
      document.head.appendChild(lastMod);
    }
    lastMod.setAttribute('content', now);
  }, [title, description, keywords, canonicalUrl, ogImage, ogType, location.pathname]);

  return null;
}